import { Popover } from "antd";
import { CUSTOMER_DATA_SERVER_URL, ROUTES } from "../App/Configs/AppConfig";
import Cold_Rolled_Steel from "./assets/img/Cold_Rolled_Steel.jpg";

export const slides = [Cold_Rolled_Steel];

export const browserInfoText =
  "You are using Internet Explorer some functionality and features may not work, please switch to Mozilla Firefox® 16.x or higher, Safari 5.1 or higher, Chrome 23 or higher, Edge 44.x or higher";

export const copyRightText =
  "Portal developed & maintained by AM/NS India IT Team";

export const homePageText =
  "ArcelorMittal NipponSteel India or AM/NS India is the leading integrated flat carbon steel producer in India, with an achievable capacity of around 8.5 million tonnes per annum. We produce a full diversified range of flat steel products, including value-added steel, and have significant capacity to produce iron ore pellets. AM/NS India, under contract from its various clients, requests bids from experienced suppliers. Detailed specifications, including BOQ and procedural guidelines, can be downloaded from here.";

export const alredyRegisteredText =
  "If you already registered, please click on the login page.";

export const successRegisteredText =
  "You will shortly receive your registered username and password on your email address.";

export const URLS = {
  ROOT: "/",
  CRP:
    process.env.REACT_APP_PROJECT_ROUTE !== "/null"
      ? process.env.REACT_APP_PROJECT_ROUTE
      : "".replace("/", ""),
  BASEROUTE: `${
    process.env.REACT_APP_PROJECT_ROUTE !== "/null"
      ? process.env.REACT_APP_PROJECT_ROUTE
      : "/"
  }`,
  PORTAL_URL: `${
    process.env.REACT_APP_PROJECT_ROUTE !== "/null"
      ? process.env.REACT_APP_PROJECT_ROUTE
      : ""
  }`,
  FORBIDDEN: "/Forbidden",
  REGISTRATION: `${
    process.env.REACT_APP_PROJECT_ROUTE !== "/null"
      ? process.env.REACT_APP_PROJECT_ROUTE
      : ""
  }/Registration`,
  REGISTERFME: `${
    process.env.REACT_APP_PROJECT_ROUTE !== "/null"
      ? process.env.REACT_APP_PROJECT_ROUTE
      : ""
  }/RegisterFME`,
  PRIVACYPOLICY: `${
    process.env.REACT_APP_PROJECT_ROUTE !== "/null"
      ? process.env.REACT_APP_PROJECT_ROUTE
      : ""
  }/PrivacyPolicy`,
  RESETUSERNAME: `${
    process.env.REACT_APP_PROJECT_ROUTE !== "/null"
      ? process.env.REACT_APP_PROJECT_ROUTE
      : ""
  }/ResetUsername`,
  RESETPASSWORD: `${
    process.env.REACT_APP_PROJECT_ROUTE !== "/null"
      ? process.env.REACT_APP_PROJECT_ROUTE
      : ""
  }/ResetPassword`,
  CHANGEPASSWORD: `${
    process.env.REACT_APP_PROJECT_ROUTE !== "/null"
      ? process.env.REACT_APP_PROJECT_ROUTE
      : ""
  }/change-password`,
  FORGETPASSWORD: `${
    process.env.REACT_APP_PROJECT_ROUTE !== "/null"
      ? process.env.REACT_APP_PROJECT_ROUTE
      : ""
  }/ForgotPassword`,
  LOGIN: `${
    process.env.REACT_APP_PROJECT_ROUTE !== "/null"
      ? process.env.REACT_APP_PROJECT_ROUTE
      : ""
  }/Login`,
  CONTACTUS: `${
    process.env.REACT_APP_PROJECT_ROUTE !== "/null"
      ? process.env.REACT_APP_PROJECT_ROUTE
      : ""
  }/ContactUs`,
  HOME: `${
    process.env.REACT_APP_PROJECT_ROUTE !== "/null"
      ? process.env.REACT_APP_PROJECT_ROUTE
      : ""
  }/Home`,
  CUSTOMER_REGISTRATION: CUSTOMER_DATA_SERVER_URL + "/crp/registrations",
  UPDATE_CUSTOMER: CUSTOMER_DATA_SERVER_URL + "/crp/registrations/",
  INIT_CR_CUSTOMER: CUSTOMER_DATA_SERVER_URL + "/crp/customer-update-data/",
  FMES: CUSTOMER_DATA_SERVER_URL + "/crp/get-fme-list?query=",
  STATES: `/${ROUTES.MASTER_ROUTE}/masters.state/list?is_active=True&country=`,
  FILE_CONFIG: CUSTOMER_DATA_SERVER_URL + "/crp/getfileconfig/Customer",
  CURRENCY: `/${ROUTES.BASE_ROUTE}/customer/crp/currency?country=`,
  DROPDOWN: `/${ROUTES.BASE_ROUTE}/masters/`,
  GET_USERDATA: CUSTOMER_DATA_SERVER_URL + "/crp/registrations/",
  CUSTOMER_LIST: CUSTOMER_DATA_SERVER_URL + "/crp/registrations/list",
  GET_REGISTRATION_FIELDS: CUSTOMER_DATA_SERVER_URL + "/crp/optional-fields",
  GET_REQ_OP_FIELDS:
    CUSTOMER_DATA_SERVER_URL +
    "/crp/req_opt_fields?screen=customer&config_for=customer",
  CUSTOMER_FILTER: `/${ROUTES.BASE_ROUTE}/master/customer.customer/list`,
  CUSTOMER_DOWNLOAD_FILE: CUSTOMER_DATA_SERVER_URL + "/crp/download-file/",
  CUSTOMER_EXPORT_EXCEL: CUSTOMER_DATA_SERVER_URL + "/crp/export",
  GET_VERSION_HISTORY: `/${ROUTES.BASE_ROUTE}/customer/crp/versions/customer.customer/`,
  REGISTER_SUCCESS: `${
    process.env.REACT_APP_PROJECT_ROUTE !== "/null"
      ? process.env.REACT_APP_PROJECT_ROUTE
      : ""
  }/RegistrationSuccess`,
  VALIDATE_EMP_CODE: `/${ROUTES.BASE_ROUTE}/customer/crp/validate-employee-code?emp_code=`,
  GET_DEFAULT_FME_VALUES: `/${ROUTES.BASE_ROUTE}/unification/customer/crp/default-values`,
  GET_INDUSTRIES: `/${ROUTES.BASE_ROUTE}/customer/crp/get-industries?system_name=`,
  DROPDOWN_BY_SOURCE: `/${ROUTES.BASE_ROUTE}/masters/listview-by-source/`,
  GET_DATA_BY_PROSPECTID: `/${ROUTES.BASE_ROUTE}/customer/crp/get-data-by-prospectid/`,
  UPDATE_REVERTED_CUSTOMER: `/${ROUTES.BASE_ROUTE}/unification/customer/update-reverted-customer/`,
  GENERATE_REGISTRATION_OTP: `/${ROUTES.BASE_ROUTE}/users/crp/generate-registration-otp/`,
  VALIDATE_REGISTRATION_OTP: `/${ROUTES.BASE_ROUTE}/users/crp/validate-registration-otp/`
};

export const NOTIFICATIONS = {
  FORM_VALIDATION:
    "Your Form Contains Multiple Errors. Please Check Your Details.",
  FORM_UPDATED_SUCCESS: "Your Data Updated Successfully.",
  fileDownloadFailed: "File Download Failed",
  excelExportError: "Error While Export Excel",
  excelExportSuccess: "Excel Export Successfully.",
  exportExportWait: "Please wait while we are exporting your excel.",
  SAVING_DATA: "Please wait while we are saving your data...",
  UPLOADING_FILES: "Please wait while we are uploading your files...",
  PLEASE_WAIT: "Please wait...",
  MOBILE: "Mobile Number or Telephone Number Cannot be Empty",
  DIRECTOR_DETAILS: "Please Enter Director Details !",
  CONTACT_PERSON_DETAILS: "Please Enter Contact Person Details !",
  MOB_INVALID: " Is not a valid mobile number.",
  TEL_INVALID: " Is not a valid telephone number.",
  EMAIL_INVALID: " Is not a valid email address.",
  VALIDATE_GST: ["Must be valid GST number"],
  SUCCESS_REGISTER: "Customer Registration Successfully.",
  EXTERNAL_NUM_RANGE:
    "Employee Code Must be between 0020000000 and 0029999999.",
  CUST_EMAIL: "Customer Email Required.",
  ERROR_OCCURED: "Error occured",
  REFRESH_PAGE:
    "Please refresh the page and try again. If the problem persists, contact crp@amns.in",
  SUSPICIOUS: "Suspicious Activity",
  TO_MANY_LOGIN: "Too many login attempts, try again after few minutes.",
  REQUIRED: "This field is required",
  INVALID_CHARACTER: "Invalid character in",
  ATLEAST_ONE_PRIMARY: "Atleast one contact person detail must be primary",
  AGREE_TANDC: "Please select term and condition checkbox",
  CORRECT_CONTACT_DETAILS: "Please correct contact person details",
  LOADING_CRM_DATA: "Please wait while we are fetching data",
  INVALID_CAPTCHA: "Invalid captcha!"
};

export const SCREEN_ROUTES = {
  VIEW_REGISTRATION_FORM: "ViewRegistrationForm",
  UPDATE_REGISTRATION_FORM: "UpdateRegistrationForm",
  CUSTOMER_LIST: "CustomerList",
  EXPORT: "",
  CHANGE_PASSWORD: "change-password",
  REGISTER: "Register",
};

export const FILE_UPLOAD_FIELDS = {
  balance_sheet_file: "balance_sheet_file",
  gst_document: "gst_document",
  pan_document: "pan_document",
  tcs_applicable_status_file: "tcs_applicable_status_file",
  tan_document: "tan_document",
  declaration_letter: "declaration_letter",
  aadhar_card_document: "aadhar_card_document",
  udyam_document: "udyam_document",
  cin_document: "cin_document",
};

export const FILE_UPLOAD_RULES = {
  filesize: "file_size_limit_mb",
  totalfiles: "no_of_files",
  allowtypes: "file_types_allowed",
};

export const SCROLL_TO_FIELD_FOR_FILE = {
  balance_sheet_file: ["annual_turnover"],
  gst_document: ["gst_number"],
  pan_document: ["pan_number"],
  tcs_applicable_status_file: ["tcs_applicable_status"],
  udyam_document: ["udyam_number"],
};

export const MULTIVALUE_FIELDS = {
  director_details: "director_details",
  company_email: "company_email",
  company_contactno: "company_contactno",
  contact_person_details: "contact_person_details",
};

export const CONTACT_PERSON_MULTIVALUE_FIELDS = {
  contact_person_email: "contact_person_email",
  contact_person_mobile_number: "contact_person_mobile_number",
  contact_person_telephone_number: "contact_person_telephone_number"
}

export const SCROLL_TO_FIELD_SERIA = {
  email: "customer_email",
  director_name: "director_details",
  company_name: "sister_company_details",
};

export const SCROLL_TO_FIELD_FOR_MULTIV = {
  contact_person_designation: "contact_person_designation",
  fme_name: "fme_name",
};

export const STATUS_WISE_RESET_FIELDS = {
  pan_number: ["pan_document"],
  gst_registration_status: ["gst_number", "gst_document"],
  tcs_applicable_status: ["tcs_applicable_status_file"],
  cin_number_status: ["cin_number"],
  tan_number_status: ["tan_document", "tan_number"],
};

export const DROPDOWN_FIELDS = {
  country: "country",
  state: "state",
  city: "city",
  fme: "fme",
  currency: "currency",
  sales_office: "sales_office",
  sales_group: "sales_group",
  app: "masters",
  industry_type: "type_of_industry"
};

export const OTHER_FIELDS = {
  city: { field: "other_city" },
};

export const CONVERT_TO_TYPE = [
  { decorator: "overall_monthly_quantity", type: parseFloat },
  { decorator: "annual_turnover", type: parseFloat },
];

export const DEPENDENT_DROPDOWN_FIELDS = {
  state: {
    app: "masters",
    model: "state",
    dependent: "country",
    storein: "statesData",
  },
  city: {
    app: "masters",
    model: "city",
    dependent: "state_code",
    country_dependent: "country",
    storein: "citiesData",
  },
  gstcode: {
    app: "masters",
    model: "gstcodes",
    dependent: "state",
    storein: "gstCodeData",
  },
  sales_group: {
    app: "masters",
    model: "salesgroup",
    dependent: "sales_office",
    storein: "salesGroupData",
  },
};

export const FIELD_ALIAS = {
  gst: { decorator: "gst_registration_status", field: "gst_registration" },
};

export const SUBMIT_VALUES = {
  DATA: "data",
  OLD_FILES: "old_files",
  FILES: "files",
  OTHER: "other",
  RECEIVE_MAILS: "receive_mails",
};

export const VERIFICATION_STATUS = {
  is_verified_in_mdm: "Verified",
  is_rejected_in_mdm: "Rejected",
  is_reverted_in_mdm: "Reverted",
  is_on_hold: "On Hold",
};

export const REMOVE_AUDIT = ["user_id"];

export const TCSRadio = {
  model: "tcsstatus",
  app: "masters",
};

export const STATIC_STRINGS = {
  VALUES: "value",
  ID: "id",
  TOOLTIP: "tooltip",
  NAME: "name",
  DISABLED: "disabled",
  director_details_status: "director_details_status",
  tan_number_status: "tan_number_status",
  tcs_applicable_status: "tcs_applicable_status",
  CIN_NUMBER_STATUS:"cin_number_status"
};

export const DECLARATION_LETTER_TOOLTIP = [
  "TDS will be deducted by Customer. Accordingly, TCS not to be charged.",
  "Customer is providing Form No. 27C, accordingly TCS is not applicable",
  "Customer is outside India, accordingly TCS is not applicable.",
  "Customer is Government Customer, accordingly, TCS is not applicable.",
];

export const DOWNLOAD_TOOLTIP = "Download declaration from here";

export const encrypt_fields = ["pan_number", "gst_number"];

export const INDIA = "india";
export const REQ_INDUSTRIES = ['pvt','public']

export const Actions = {
  insert: "insert",
  update: "update",
  delete: "delete",
  status: "status",
  radio: "Radio",
  add: "Add",
};

export const STATUS_RADIO = {
  primary: "Primary",
  secondary: "Secondary",
  inactive: "Inactive",
};

export const director_fields = [
  "director_name",
  "director_email",
  "director_contactno",
];

export const dire_detai_columnsDefs = [
  {
    headerName: "Name",
    field: "director_name",
  },
  {
    headerName: "Email",
    field: "director_email",
  },
  {
    headerName: "Contact No",
    field: "director_contactno",
  },
];

// TO GET TOOL TIP TITLE FOR MULTIVALUE FIELDS e.g contact person emails, tele, mobile
export function getTitleForMultiValueFields(values) {
  values = values ? values : "";
  return (
    <ol>
      {values.split(",").map((e) => (
        <li style={{fontWeight: 100}}>{e}</li>
      ))}
    </ol>
  );
}

export const contact_person_columnsDefs = [
  {
    headerName: "Title",
    field: "person_title",
  },
  {
    headerName: "First Name",
    field: "contact_person_first_name",
  },
  {
    headerName: "Last Name",
    field: "contact_person_last_name",
  },
  {
    headerName: "Designation",
    field: "designation",
  },
  {
    headerName: "Department",
    field: "department",
  },
  {
    headerName: "Mobile Number",
    field: "contact_person_mobile_number",
    resizable: true,
    cellRendererFramework: function (params) {
      return (
        <Popover
          placement="topLeft"
          title="Mobiles"
          content={() => getTitleForMultiValueFields(params.value)}
        >
          {params.value}
        </Popover>
      );
    },
  },
  {
    headerName: "Telephone Number",
    field: "contact_person_telephone_number",
    cellRendererFramework: function (params) {
      return (
        <Popover
          placement="topLeft"
          title="Telephones"
          content={() => getTitleForMultiValueFields(params.value)}
        >
          {params.value}
        </Popover>
      );
    },
  },
  {
    headerName: "Email ID",
    field: "contact_person_email",
    cellRendererFramework: function (params) {
      return (
        <Popover
          placement="topLeft"
          title="Emails"
          content={() => getTitleForMultiValueFields(params.value)}
        >
          {params.value}
        </Popover>
      );
    },
  },
];

export const India = "India";

export const UNITED_STATES = "United States";

export const EXCLUDE_FIELDS_DIFF = [
  "auth_username",
  "country_name",
  "created_by",
  "created_date",
  "customer",
  "disable_fields",
  "employee_name",
  "files",
  "id",
  "is_active",
  "is_approved",
  "is_deleted",
  "is_on_hold",
  "is_rejected_in_mdm",
  "is_reverted_in_mdm",
  "is_verified_in_mdm",
  "last_updated_by",
  "last_updated_date",
  "name",
  "show_save",
  "status",
  "user",
  "gst_registration_status",
];

export const DIRECTOR_FIELDS = [
  "director_name",
  "director_contactno",
  "director_email",
];

export const CONTACT_PERSON_FIELDS = [
  "contact_person_title",
  "contact_person_last_name",
  "contact_person_first_name",
  "contact_person_designation",
  "contact_person_department",
  "contact_person_mobile_number",
  "contact_person_telephone_number",
  "contact_person_email",
];

export const CONTACT_PERSON_VALIDATION_FIELDS = [
  "contact_person_title",
  "contact_person_last_name",
  "contact_person_first_name",
  "contact_person_designation",
  "contact_person_department",
];

export const DOMAINS = [".com", ".co.in", ".org", ".net", ".in"];

export const TO_DECIMAL = [
  { decorator: "annual_turnover", decimal: 10 },
  { decorator: "overall_monthly_quantity", decimal: 3 },
];

export const REFRESH_NOTIFICATION = {
  message: "Submit Form",
  description:
    "This is a session based form and you may loose your input information due to inactivity.",
};

export const QUERY = {
  by_source: "?source=",
  dependent: "&dependent=",
  id: "&id=",
  source: "source",
  reference: "reference",
  ecommerce: "e-commerce",
  msme: "msme",
  prospectId: "prospect",
  cfs: "cfs"
};

export const COOKIE_EXPIRY_DATE = "Thu, 01 Jan 1970 00:00:00 UTC;";

export const SHIPPING_BILLING_MSG = [
  "Since your shipping and billing address is not same. Please refer below url to add shipping address.",
  "We have saved your shipping address. Refer below url to add more shipping address.",
];

export const CIN_HELPER_TEXT = `Please put CIN in “X00000XX0000XXX000000” format where “X” denotes alphabet and “0” denotes number. For example, - CIN number of AMNS India Limited is U27100GJ1976FLC013787`;

export const SHIPPING_BILLING_URL = (uuid, source) => {
  return (
    URLS.REGISTRATION + `?reference=${uuid}${source ? "&source=" + source : ""}`
  );
};

export const AVOID_IN_TRIM = [
  "contact_person_title",
  "contact_person_designation",
  "contact_person_department",
];

export const RETAIN_VALUES = [
  { decorator: "contact_person_department", alias: "department" },
  { decorator: "contact_person_designation", alias: "designation" },
  { decorator: "contact_person_title", alias: "person_title" },
];

export const MISC_DECORATORS = {
  udyam_number: "udyam_number",
};

export const randomString = (length) => {
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
  var randomstring = "";

  //loop to select a new character in each iteration
  for (var i = 0; i < length; i++) {
    var rnum = Math.floor(Math.random() * characters.length);
    randomstring += characters.substring(rnum, rnum + 1);
  }

  return randomstring;
};

export const SOURCE_KHOPOLI = "khopoli";